import React from 'react';
import '../stylesheets/Menus.css';
import './CardDisplay.css';

const DECK_LOGOS = {
    'Real Talk': 'rt',
    'Stand Up & Speak Out': 'suso',
    'Behind the Mask': 'btm',
    'Power Moves': 'pm',
    'Ripple Effects': 're',
    'Drop the Mic': 'dtm',
    'Fun Interactions': 'fi',
    'Self Care Squad': 'scs',
    'Drop the Anchor': 'dta',
    'Flip the Script': 'fts',
};

export default function CardDisplay({ card }) {
    if (!card) {
        return null;
    }

    const logoFile = DECK_LOGOS[card.deckName];
    const logoSrc = logoFile ? `/assets/${logoFile}.png` : null;

    return (
        <div className="card-display">
            <div className="card-display-title">{card.deckName}</div>

            {logoSrc && (
                <img className="card-display-logo" draggable={false} src={logoSrc} alt={`${card.deckName} deck logo`} />
            )}

            <div className="card-display-prompt">{card.prompt}</div>
        </div>
    );
}